import React from 'react'
import Hero from '../../components/hero/Hero'
import PagesChecklist from '../../components/pages/PagesChecklist'
import './Posicionamiento.css'
import ButtonMain from '../../components/ButtonMain'

function Posicionamiento() {
    return (
        <div className="posicionamientoWrapper">
            <Hero
            title="Posicionamiento."
            title2="Google, Google Shopping, GDN y más."
            sub="Posicionamos negocios en internet con campañas atractivas. Descrubre nuevos clientes y haz crecer tu negocio online."
            />
            <PagesChecklist
                subtitle="Creamos valor para tu negocio en internet."
                checklist1="Encuentra tu página web en las primeras posiciones."
                checklist2="Controla el gasto y el terno de tu inversión."
                checklist3="Consigue nuevos clientes y verbaliza tu marca."
                checklist4="Transforma tu negocio y compite en internet."
            />
            <div style={{height:"90px"}}/>
            <PagesChecklist
                subtitle="Canales y modelos de publicidad que gestionamos."
                checklist1="Google Ads, tu negocio en las primeras posiciones."
                checklist2="Google Display Network, visibilidad en emplazamientos."
                checklist3="Google Shopping, tus productos arriba."
                checklist4="Google Partners, aparece en otros buscadores."
            />
            <div style={{marginLeft:"10vw"}}>
            <ButtonMain mainbtn="¿Nos conectamos?"/>
            </div>
        </div>
    )
}

export default Posicionamiento
